module.exports = __webpack_public_path__ + "img/app_icon (2).256b2e48.png";